import React from "react";
import { ItemFormGroup } from '../FormElements/ItemFormGroup';
import { IdentifierFormGroup } from '../FormElements/IdentifierFormGroup';
import { GeneralFields } from './GeneralFields';
import { LanguageSelect } from "../FormElements/LanguageSelect";
import { SerialFileInfo } from "../FormElements/SerialFileInfo";
import { AddFilesButton } from "../FormElements/AddFilesButton";
import { UrlField } from "../FormElements/UrlField";

import { Row, Col } from 'react-bootstrap';
import lang from '../Localization';

class SerialView extends React.Component {
    render() {
        const files = this.props.item.getFiles("main").map((f) => <SerialFileInfo appFunctions={this.props.appFunctions} key={f.tmpFilename} item={this.props.item} file={f} forceShowErrors={this.props.forceShowErrors} />)

        return (
            <div>
                <Row>
                    <Col md>
                        <h3>{lang.basicInformation}</h3>
                        <div>
                            <span style={{color:"red"}}>*</span> = {lang.fieldRequired}
                        </div>
                        <IdentifierFormGroup identifier={"issn"} helpTextKey={"serialISSN"} needsToBeValid={true} {...this.props} />
                        <ItemFormGroup required={true} field={"title"} helpTextKey={"serialTitle"} {...this.props} />
                        <ItemFormGroup field={"subtitle"} {...this.props} />
                        <ItemFormGroup required={true} field={"publisher"} labelTextKey={"publisher_and_alt"} {...this.props} />
                        <ItemFormGroup field={"placeOfPublication"} {...this.props} />
                        <ItemFormGroup field={"yearOfPublication"} labelTextKey={"yearOfPublicationForSerial"} helpTextKey={"yearOfPublicationForSerial"} {...this.props} />
                        <LanguageSelect {...this.props} />
                    </Col>
                    <Col md>
                        <h3>{lang.volumes}</h3>
                        {files}
                        <div>
                            <AddFilesButton message={lang.addFile} item={this.props.item} appFunctions={this.props.appFunctions} />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <UrlField {...this.props} />
                    </Col>
                </Row>

                <GeneralFields item={this.props.item} appFunctions={this.props.appFunctions} />
            </div>
        );
    }
  }

  export { SerialView }